<template>
  <b-button
    :to="to"
    :variant="variant"
    :size="size"
    :block="block"
    :disabled="disabled"
    @click="handleClick"
    :class="[size === 'sm' ? 'btn-size-sm' : 'btn-size']"
    class="btn-effects"
  >
    <slot>Button</slot>
  </b-button>
</template>

<script>
export default {
  name: 'BaseButtonComponent',
  props: {
    to: { type: String, default: null },
    variant: { type: String, default: 'primary' },
    size: { type: String, default: null },
    block: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
  },
  emits: ['click'],
  methods: {
    handleClick(event) {
      this.$emit('click', event);
    },
  },
};
</script>

<style lang="scss" scoped>
.btn-size-sm {
  min-width: 64px;
}
.btn-size {
  min-width: 130px;
}
.btn-effects {
  transition: background-color 0.3s, border-color 0.3s, color 0.3s;
  cursor: pointer;
}
.btn-effects:hover {
  filter: brightness(90%);
}
</style>
